import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AFVendorBatchRequestDomain, VendorRequestDomain, VendorTakeActionDomain, AFVendorRequest, VendorResultsDomain, AFVendorResponseDomain } from '../model/af.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  focusPage: EventEmitter<string> = new EventEmitter();

  constructor(private userService: AuthService, private http: HttpClient) {
  }

  getVendorRequest(): Observable<VendorRequestDomain> {
    return this.http.post<VendorRequestDomain>(environment.api_uri + 'getVendorRequest', { 'verifyId': this.userService.getVerifyId() });
  }

  submitVendorRequest(VendorRequestDomain): Observable<AFVendorRequest> {
    const requestUrl = environment.api_uri + 'submitVendorRequest';
    return this.http.post<AFVendorRequest>(requestUrl, VendorRequestDomain);
  }

  searchVendorResponse(ResultsDomain: AFVendorResponseDomain): Observable<VendorResultsDomain[]> {
    const requestUrl = environment.api_uri + 'searchVendorResponse';
    return this.http.post<VendorResultsDomain[]>(requestUrl, ResultsDomain);
  }

  getVendorBatchRequest(): Observable<AFVendorBatchRequestDomain> {
    return this.http.post<AFVendorBatchRequestDomain>(environment.api_uri + 'getVendorBatchRequest', { 'verifyId': this.userService.getVerifyId() });
  }

  downloadBatchRequest(batchRequestId: number, verifyId: string, fileName: string): Observable<any> {
    let params = new HttpParams().set("batchRequestId", batchRequestId).set("verifyId", verifyId);
    let headers = new HttpHeaders({
      "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    return this.http.post(environment.api_uri + "downloadBatchRequest", params, { headers: headers, responseType: "blob" }).pipe(
      tap((response: Blob) => {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        // Browsers require downloads from an <a> for security purposes, generating a 
        // temporary link to download directly to the browser in this way is supported by all browsers. 
        // Not all browsers currently support APIs that handle this.
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }),
      catchError(error => {
        console.log("Error downloading file: ", error);
        return throwError(() => error);
      }));
  }

  loadTakeActionScreen(auditIds: string, caseNumber: string, applicantName: string,
    entityId: string, containerId: number): Observable<VendorTakeActionDomain> {
    return this.http.get<VendorTakeActionDomain>(environment.api_uri + "loadTakeActionScreen?verifyId=" + this.userService.getVerifyId() +
      "&auditIds=" + auditIds +
      "&caseNumber=" + caseNumber +
      "&applicantName=" + applicantName +
      "&entityId=" + entityId +
      "&containerId=" + containerId);
  }

  searchVendorTakeActionResponse(auditIds: string): Observable<VendorTakeActionDomain[]> {
    return this.http.get<VendorTakeActionDomain[]>(environment.api_uri + 'searchVendorTakeActionResponse?verifyId=' + this.userService.getVerifyId() +
      "&auditIds=" + auditIds);
  }

  takeActionWithdraw(containerId: number): Observable<string> {
    return this.http.get<string>(environment.api_uri + "takeActionWithdraw?verifyId=" + this.userService.getVerifyId() + "&containerId=" + containerId);
  }

  vendorUpdateEmail(entityId: string, emailAddress: string): Observable<string> {
    return this.http.get<string>(environment.api_uri + "vendorUpdateEmail?verifyId=" + this.userService.getVerifyId() +
      "&entityId=" + entityId +
      "&emailAddress=" + emailAddress);
  }

  resendEmail(auditIds: string, caseNumber: string): Observable<string> {
    return this.http.get<string>(environment.api_uri + "resendEmail?verifyId=" + this.userService.getVerifyId() + "&emailAuditId=" + auditIds +
      "&caseId=" + caseNumber);
  }

  emitFocusPage(page: string) {
    this.focusPage.emit(page);
  }

  getFocusEmitter(): Observable<string> {
    return this.focusPage;
  }
}
